import { sendPv } from '@/utils/logTrack.js'
import 'requestidlecallback-polyfill'
const typeList = ['css', 'img', 'xmlhttprequest', 'js', 'script', 'link', 'embed', 'fetch']
const whiteList = ['analysis.chatglm.cn', 'zhipuaishengchan.datasink.sensorsdata.cn']

const RIC =
  window.requestIdleCallback || window.msRequestIdleCallback || window.webkitRequestIdleCallback

function captureResourceTime() {
  const performance = window.performance || window?.msPerformance || window?.webkitPerformance
  if (!performance) return
  const resource = performance.getEntriesByType('resource')
  const slow_resources = resource.filter(
    item =>
      item.duration > 500 &&
      typeList.includes(item.initiatorType) &&
      whiteList.every(w => item?.name?.indexOf?.(w) === -1)
  )
  if (!slow_resources?.length) return
  RIC(() => {
    slow_resources.forEach(item => {
      sendPv({
        md: 'performance',
        ct: 'web_time_resource',
        ctvl: window.location.pathname,
        pds: item?.initiatorType,
        ctnm: item?.duration,
        extra: item?.name
      })
    })
  })
}
export default captureResourceTime
